import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class AssignmentReportsGridPostParams extends GridPostParams {
    reportTypeFlag: number = 4;
    search_keyword: any = '';
    region_search: string = '';
    batch_search: any = '';
    branch_search: any = '';
    state_search: any = '';
    gender_search: string = ''
    status_search: any = '';
    location_search: any = '';
    type_search: any = '';
    cat_search: any = '';
}